const services = [{
  id: 1,
  name: 'Notification Service',
}];

module.exports = services;
